import { Injectable } from '@angular/core';
import { ApiServices } from '../shared/services/api.services';
import { ApiConstants } from '../shared/constants/api.constants';

@Injectable()
export class LoginService {
    constructor(private apiService: ApiServices, private apiConstants: ApiConstants) {
    }

    login(params: Object) {
        const header = { 'Content-Type': 'application/json' };
        return this.apiService.serviceCall(
            this.apiConstants.authUrl.auth.url,
            this.apiConstants.authUrl.auth.method,
            params,
            null,
            header
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/login/login.service.ts